import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BrandSymbol from '../ui/BrandSymbol';
import { API_BASE_URL } from '../../config/api';
import { useSubscriptionStatus } from '../../hooks/useSubscriptionStatus';

const ONBOARDING_TUTORIAL_ID = 'onboarding_video';

const Frame134: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Extract firstName passed from Frame129
  const redirectTo = (location.state as { redirectTo?: string })?.redirectTo || '/frame-140';
  const { status, hasAccess, isLoading, error } = useSubscriptionStatus();


  useEffect(() => {
    if(!isLoading) {
      if(status != 'active' && status != 'trialing') {
        navigate('/frame-250');
      }
    }
  }, [status, hasAccess, isLoading, error]);

  const handleGetStarted = async () => {
    const token = localStorage.getItem('account-token');

    if (token) {
      try {
        await fetch(`${API_BASE_URL}/api/user/tutorial-dismissed/${ONBOARDING_TUTORIAL_ID}`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` }
        });
      } catch (error) {
        console.error('Failed to persist onboarding completion:', error);
      }
    }

    navigate(redirectTo, { state: { fromOnboarding: true }});
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-900 to-slate-900 flex justify-center pt-7 pb-16 px-4 relative">
      {/* White container */}
      <div className="relative bg-stone-50 rounded-md shadow-[0_0_16px_4px_rgba(49,49,33,0.20)] w-full max-w-[1130px] h-[800px] flex flex-col items-center">
      {/* Radial gradient decoration */}
      <div className="absolute bottom-0 left-0 w-full h-72 bg-[radial-gradient(ellipse_177.34%_93.90%_at_48.58%_161.71%,_#65ADC1_0%,_#E7F2F6_100%)] pointer-events-none" />

        {/* Logo and title */}
        <div className="w-full max-w-[692px] mt-10 flex flex-col items-center"> 
          <BrandSymbol size="4xl" showText={true} variant="dark"/>
        </div>

        {/* Intro card */}
        <div className="relative z-10 bg-white rounded-md shadow-[0_0_16px_4px_rgba(49,49,33,0.20)] w-full max-w-[692px] mt-2 p-8 space-y-6 flex flex-col items-start">
          <p className="font-display text-2xl font-semibold text-green-700 leading-loose max-w-[620px]">
            Welcome. End of an Era will walk you through everything you need to know about planning your estate.
          </p>
          {/* YouTube Video Embed */}
          <div className="w-full max-w-[620px] h-80 rounded-[5px] overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/pDVy7xNnyqI?autoplay=1&mute=1&rel=0"
              title="End of an Era Onboarding Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
          <button
            onClick={handleGetStarted}
            className="mt-6 self-center px-6 py-3 rounded bg-cyan-700 text-stone-50 font-medium flex items-center gap-2 hover:bg-cyan-800"
          >
            Get Started <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Frame134; 